var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#EAFAF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20C30 20.875 29.6875 21.6875 29.25 22.3125L31.0625 26.25C31.6875 26.125 32.3125 26 33 26C35.25 26 37.3125 26.875 38.875 28.25L44 24.4375C44 24.3125 44 24.1875 44 24C44 21.8125 45.75 20 48 20C50.1875 20 52 21.8125 52 24C52 26.25 50.1875 28 48 28C47.375 28 46.875 27.9375 46.375 27.6875L41.25 31.4375C41.6875 32.5625 42 33.75 42 35C42 36 41.8125 36.9375 41.5 37.8125L46 40.5C46.625 40.1875 47.25 40 48 40C50.1875 40 52 41.8125 52 44C52 46.25 50.1875 48 48 48C45.75 48 44 46.25 44 44V43.9375L39.4375 41.25C37.8125 42.9375 35.5 44 33 44C28.6875 44 25.125 41.0625 24.1875 37H19.4375C18.75 38.25 17.4375 39 16 39C13.75 39 12 37.25 12 35C12 32.8125 13.75 31 16 31C17.4375 31 18.75 31.8125 19.4375 33H24.1875C24.6875 30.9375 25.8125 29.1875 27.4375 27.9375L25.625 24C23.5625 23.8125 22 22.125 22 20C22 17.8125 23.75 16 26 16C28.1875 16 30 17.8125 30 20ZM33 38C34.0625 38 35 37.4375 35.5625 36.5C36.125 35.625 36.125 34.4375 35.5625 33.5C35 32.625 34.0625 32 33 32C31.875 32 30.9375 32.625 30.375 33.5C29.8125 34.4375 29.8125 35.625 30.375 36.5C30.9375 37.4375 31.875 38 33 38Z",
    fill: "#2FB273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.0c6adc32e95399777497b141640b8709.svg";
export { ForwardRef as ReactComponent };